import { Component, OnInit } from '@angular/core';
import { MedicoService } from 'src/app/services/medico.service';
import { AuthService } from '../../../../services/auth.service';

@Component({
  selector: 'app-medico',
  templateUrl: './medico.component.html',
  styleUrls: ['./medico.component.scss']
})
export class MedicoComponent implements OnInit {

  public totalCasosClinicos: number | undefined = 0;
  public totalProductos: number | undefined = 0;
  public totalPuntos: number | undefined = 0;
  public saldo: number | undefined = 0;

  ngOnInit(): void {
    console.log('Medico Component Cargado..');
  }

  constructor(
    public authService: AuthService,
    private medicoService: MedicoService) {
    if (this.authService.getUsuario) {
      const id: number | undefined = this.authService.getUsuario.medico?.id;
      if (id) this.obtenerInformacion(id);
    }
  }

  obtenerInformacion(id: number): void {

    this.medicoService.totales(id).subscribe({
      next: (resp) => {
        this.totalCasosClinicos = resp.datos.casosclinicos;
        this.totalProductos = resp.datos.productos;
        this.totalPuntos = resp.datos.puntos;
        this.saldo = resp.datos.saldo;
        console.log(resp)
      },
      error: (err) => console.log(err)
    })

  }

  mensaje(mensaje: string): void {
    if (this.authService.getUsuario) {
      const id: number | undefined = this.authService.getUsuario.medico?.id;
      if (id) this.obtenerInformacion(id);
    }
  }
}
